import { Plus } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import Graytextarea from '../../../src/components/Graytextarea'
import { CModal, CModalBody, CModalFooter, CFormLabel, CFormInput, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CModalHeader, CModalTitle, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CFormTextarea } from '@coreui/react'
import SaveExtra from '../../services/general/saveExtraData.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import Select from 'react-select'
const PatientIncidet = ({ diagnosisName, isAllotedToProvider = false, addedNewIncident, saveTreatsShell, patientDifferentialDiagnosis, selectedDifferentialDiagnosis, setSelectedDifferentialDiagnosis, noteStructureRef }) => {
  const [visible, setVisible] = useState(false)
  const [allIncidents, setAllIncidents] = useState([])
  const [questionDatas, setQuestionDatas] = useState([])

  useEffect(() => {
    if (noteStructureRef?.current?.incident) {
      const allKeys = Object.keys(noteStructureRef?.current?.incident)

      const filteredKeys = allKeys.filter((key) => key.startsWith(diagnosisName))

      const allIncidentsWithDates = filteredKeys.map((key) => {
        const date = key.split(`${diagnosisName}_`)[1]
        return {
          date: date,
          incidents: noteStructureRef?.current?.incident[key],
        }
      })

      setAllIncidents(allIncidentsWithDates)
    }
  }, [diagnosisName, noteStructureRef, addedNewIncident])
  const getIncidents = async () => {
    let diagnosisData = await GetDiagnosisData('')
    diagnosisData = JSON.parse(diagnosisData.d)?.Data

    const findDiagnosisId = diagnosisData?.find((item) => item.Name === diagnosisName)

    if (findDiagnosisId) {
      let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId.id, '')
      data = JSON.parse(data?.d)?.Data || []

      const allParsedData = data.flatMap((item) => {
        try {
          const parsed = JSON.parse(item.questionData)
          return Array.isArray(parsed) ? parsed : []
        } catch (err) {
          console.error('Invalid JSON in questionData:', item.questionData)
          return []
        }
      })
      setQuestionDatas(allParsedData)
    }
  }

  useEffect(() => {
    getIncidents()
  }, [])

  const handleSubmit = () => {
    const key = `${diagnosisName}_${new Date().toISOString()}`
    noteStructureRef.current = {
      ...noteStructureRef.current,
      incident: {
        ...noteStructureRef.current.incident,
        [key]: questionDatas,
      },
    }
    saveTreatsShell()
    setVisible(false)
    setQuestionDatas([])
  }

  return (
    <>
      <div>
        <div className="mt-2 d-flex gap-3 align-items-center">
          <h7>
            <b>Incident</b>
          </h7>
          {/* {isAllotedToProvider && <CFormLabel
            className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
            onClick={() => setVisible((p) => !p)}
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "20px",
              background: "var(--ui-color-primary, #2b7cd3)",
              cursor: "pointer",
            }}
          >
            <Plus className="text-white" strokeWidth={2} size={15} />
          </CFormLabel>} */}
        </div>
        <hr />
        <div className="d-flex flex-column gap-4">
          {allIncidents.length > 0 &&
            allIncidents.map((incident, index) => {
              return (
                <div>
                  <p className="p-0 m-0 " style={{ fontWeight: 'bold' }}>
                    {new Date(incident.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })}
                  </p>
                  <div>
                    {incident?.incidents.length > 0 && (
                      <p className="" style={{ whiteSpace: 'pre-line' }}>
                        {incident?.incidents[0]?.freeRemark || ''}
                      </p>
                    )}

                    {incident.incidents &&
                      incident.incidents.length > 0 &&
                      incident.incidents.map((incidentItem, index) => {
                        return (
                          incidentItem.answer && (
                            <div>
                              <div key={index}>
                                {' '}
                                {/* It's important to add a unique key when rendering lists */}
                                <p className="p-0 m-0">
                                  {index + 1}. {incidentItem.label}
                                </p>
                                <p className="p-0 m-0">
                                  {' '}
                                  <strong>Answer:</strong> {incidentItem.answer}
                                </p>
                              </div>
                              {incidentItem?.freeType && (
                                <div>
                                  {' '}
                                  <strong>Freetype:</strong>
                                  {incidentItem?.freeType}
                                </div>
                              )}
                            </div>
                          )
                        )
                      })}
                  </div>
                </div>
              )
            })}
        </div>
      </div>
      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalBody className="">
          {questionDatas.map((item, idx) => {
            return (
              <div key={item.id} className="mb-3">
                <div className="d-flex items-center gap-1">
                  <p>{idx + 1}.</p>
                  <CFormLabel>{item.label}</CFormLabel>
                </div>

                {item.type === 'dropdown' && (
                  <Select
                    onChange={(e) => {
                      setQuestionDatas((prevData) => {
                        const newData = [...prevData]
                        newData[idx].answer = e.value
                        return newData
                      })
                    }}
                    placeholder="Select an option"
                    value={item.answer ? { value: item.answer, label: item.answer } : null}
                    options={
                      item.options?.map((opt) => ({
                        value: opt.label || opt.label,
                        label: opt.label,
                      })) || []
                    }
                  />
                )}

                <span className="d-block pt-2">
                  <Graytextarea
                    value={item.freeType}
                    onChange={(e) => {
                      setQuestionDatas((prevData) => {
                        const newData = [...prevData]
                        newData[idx].freeType = e.target.value
                        return newData
                      })
                    }}
                    height={'100px'}
                    placeholder={'Freetype'}
                  />
                </span>
              </div>
            )
          })}
        </CModalBody>
        <CModalFooter>
          <CButton onClick={() => setVisible(false)} color="secondary">
            Close
          </CButton>
          <CButton onClick={handleSubmit}>Save Changes</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientIncidet
